import React from "react";
import { StatusPage } from "@pages/status-page/ui/StatusPage";

export const App = () => {
    return <StatusPage />;
};
